import React, { useState, useEffect } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { ChevronLeft, ChevronRight, Star, Quote } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const Testimonials = ({ currentLang, translations }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [titleRef, titleVisible] = useScrollAnimation();
  const [carouselRef, carouselVisible] = useScrollAnimation();

  const testimonials = [
    {
      id: 1,
      name_en: "David Cohen",
      name_he: "דוד כהן", 
      name_ru: "Давид Коэн",
      location_en: "Tel Aviv",
      location_he: "תל אביב",
      location_ru: "Тель-Авив",
      text_en: "Amazing service! Lost my BMW keys at the beach and XKey24 had me back on the road in 30 minutes. Professional, fast, and reasonably priced.",
      text_he: "שירות מדהים! איבדתי את מפתחות ה-BMW בחוף ו-XKey24 החזירה אותי לדרך תוך 30 דקות. מקצועי, מהיר ובמחיר סביר.",
      text_ru: "Потрясающий сервис! Потерял ключи от BMW на пляже, и XKey24 вернули меня в дорогу за 30 минут. Профессионально, быстро и по разумной цене.",
      rating: 5,
      service_en: "BMW Key Replacement",
      service_he: "החלפת מפתח BMW",
      service_ru: "Замена ключа BMW"
    },
    {
      id: 2,
      name_en: "Sarah Levi",
      name_he: "שרה לוי",
      name_ru: "Сара Леви", 
      location_en: "Ramat Gan",
      location_he: "רמת גן",
      location_ru: "Рамат Ган",
      text_en: "Excellent emergency service! Called them at 11 PM when locked out with my baby in the car. They arrived within 15 minutes and opened it safely.",
      text_he: "שירות חירום מעולה! התקשרתי אליהם ב-23:00 כשננעלתי מחוץ לרכב עם התינוק שלי בפנים. הם הגיעו תוך 15 דקות ופתחו בבטחה.",
      text_ru: "Отличная служба экстренного реагирования! Вызвала их в 23:00, когда заперлась с ребенком в машине. Приехали за 15 минут и безопасно открыли.",
      rating: 5,
      service_en: "Emergency Lockout",
      service_he: "פתיחת חירום",
      service_ru: "Экстренное вскрытие"
    },
    {
      id: 3,
      name_en: "Michael Rosenberg",
      name_he: "מיכאל רוזנברג",
      name_ru: "Михаил Розенберг",
      location_en: "Herzliya",
      location_he: "הרצליה", 
      location_ru: "Герцлия",
      text_en: "Fixed my Tesla Model 3 key card issue perfectly. The technician was knowledgeable about electric vehicles and solved the problem quickly.",
      text_he: "תיקן את בעיית כרטיס המפתח של טסלה מודל 3 שלי בצורה מושלמת. הטכנאי היה בקיא ברכבים חשמליים ופתר את הבעיה במהירות.",
      text_ru: "Идеально починили проблему с ключ-картой Tesla Model 3. Техник разбирался в электромобилях и быстро решил проблему.",
      rating: 5,
      service_en: "Tesla Key Programming",
      service_he: "תכנות מפתח טסלה",
      service_ru: "Программирование ключа Tesla"
    },
    {
      id: 4,
      name_en: "Rachel Ben-David",
      name_he: "רחל בן-דוד",
      name_ru: "Рахель Бен-Давид",
      location_en: "Petah Tikva", 
      location_he: "פתח תקווה",
      location_ru: "Петах Тиква",
      text_en: "Professional and reliable service. My Audi ignition was completely stuck, and they replaced it the same day. Great communication throughout.",
      text_he: "שירות מקצועי ואמין. ההתנעה של האודי שלי הייתה תקועה לחלוטין, והם החליפו אותה באותו היום. תקשורת מעולה לאורך כל הדרך.",
      text_ru: "Профессиональный и надежный сервис. Зажигание Audi было полностью заблокировано, они заменили его в тот же день. Отличное общение.",
      rating: 5,
      service_en: "Audi Ignition Repair",
      service_he: "תיקון התנעה אודי",
      service_ru: "Ремонт зажигания Audi"
    },
    {
      id: 5,
      name_en: "Yossi Goldstein",
      name_he: "יוסי גולדשטיין",
      name_ru: "Йосси Гольдштейн",
      location_en: "Jerusalem",
      location_he: "ירושלים",
      location_ru: "Иерусалим",
      text_en: "Outstanding service for my Ford Focus key programming. Fair pricing, quick response time, and the key works perfectly. Highly recommended!",
      text_he: "שירות יוצא דופן לתכנות מפתח פורד פוקוס שלי. תמחור הוגן, זמן תגובה מהיר והמפתח עובד בצורה מושלמת. ממליץ בחום!",
      text_ru: "Выдающийся сервис программирования ключа Ford Focus. Справедливая цена, быстрое время отклика, ключ работает идеально. Очень рекомендую!",
      rating: 5,
      service_en: "Ford Key Programming",
      service_he: "תכנות מפתח פורד",
      service_ru: "Программирование ключа Ford"
    },
    {
      id: 6,
      name_en: "Elena Volkov",
      name_he: "אלנה וולקוב",
      name_ru: "Елена Волков",
      location_en: "Ashdod",
      location_he: "אשדוד",
      location_ru: "Ашдод", 
      text_en: "Excellent service! My Hyundai key stopped working after water damage. They diagnosed and fixed it within an hour. Very professional team.",
      text_he: "שירות מעולה! המפתח של היונדאי שלי הפסיק לעבוד אחרי נזק מים. הם איבחנו ותיקנו אותו תוך שעה. צוות מקצועי מאוד.",
      text_ru: "Отличный сервис! Ключ от Hyundai перестал работать после повреждения водой. Диагностировали и починили за час. Очень профессиональная команда.",
      rating: 5,
      service_en: "Hyundai Key Repair",
      service_he: "תיקון מפתח יונדאי", 
      service_ru: "Ремонт ключа Hyundai"
    },
    {
      id: 7,
      name_en: "Ahmed Mansour",
      name_he: "אחמד מנסור",
      name_ru: "Ахмед Мансур",
      location_en: "Haifa",
      location_he: "חיפה",
      location_ru: "Хайфа",
      text_en: "Fast and efficient service for my Mercedes transponder programming. The technician arrived on time and completed the job professionally.",
      text_he: "שירות מהיר ויעיל לתכנות הטרנספונדר של המרצדס שלי. הטכנאי הגיע בזמן וסיים את העבודה בצורה מקצועית.",
      text_ru: "Быстрый и эффективный сервис программирования транспондера Mercedes. Техник прибыл вовремя и выполнил работу профессионально.",
      rating: 5,
      service_en: "Mercedes Transponder",
      service_he: "טרנספונדר מרצדס",
      service_ru: "Транспондер Mercedes"
    },
    {
      id: 8,
      name_en: "Olga Ivanova",
      name_he: "אולגה איבנובה",
      name_ru: "Ольга Иванова",
      location_en: "Netanya",
      location_he: "נתניה",
      location_ru: "Нетания",
      text_en: "Amazing experience! Lost my Mazda keys during a family outing. XKey24 created new keys on-site and saved our weekend. Thank you!",
      text_he: "חוויה מדהימה! איבדתי את מפתחות המאזדה במהלך טיול משפחתי. XKey24 יצרו מפתחות חדשים במקום והצילו לנו את הסוף השבוע. תודה!",
      text_ru: "Потрясающий опыт! Потеряла ключи от Mazda во время семейной прогулки. XKey24 сделали новые ключи на месте и спасли наши выходные. Спасибо!",
      rating: 5,
      service_en: "Mazda Key Creation",
      service_he: "יצירת מפתח מאזדה",
      service_ru: "Создание ключа Mazda"
    },
    {
      id: 9,
      name_en: "Jonathan Miller",
      name_he: "יונתן מילר",
      name_ru: "Джонатан Миллер",
      location_en: "Rishon LeZion",
      location_he: "ראשון לציון", 
      location_ru: "Ришон ле-Цион",
      text_en: "Top-notch service for my Volkswagen ignition replacement. Transparent pricing, quality work, and excellent customer service throughout.",
      text_he: "שירות ברמה הגבוהה ביותר להחלפת ההתנעה של הפולקסווגן שלי. תמחור שקוף, עבודה איכותית ושירות לקוחות מעולה לאורך כל הדרך.",
      text_ru: "Первоклассный сервис замены зажигания Volkswagen. Прозрачное ценообразование, качественная работа и отличное обслуживание клиентов.",
      rating: 5,
      service_en: "VW Ignition Replacement",
      service_he: "החלפת התנעה פולקסווגן",
      service_ru: "Замена зажигания VW"
    },
    {
      id: 10,
      name_en: "Maria Rodriguez",
      name_he: "מריה רודריגס",
      name_ru: "Мария Родригес",
      location_en: "Beer Sheva",
      location_he: "באר שבע",
      location_ru: "Беэр-Шева",
      text_en: "Exceptional emergency service! Called them at midnight for a Nissan lockout. Professional, courteous, and solved the problem quickly.",
      text_he: "שירות חירום יוצא דופן! התקשרתי אליהם בחצות בגלל נעילה של ניסאן. מקצועי, אדיב ופתר את הבעיה במהירות.",
      text_ru: "Исключительная служба экстренного реагирования! Вызвала их в полночь из-за блокировки Nissan. Профессионально, вежливо и быстро решили проблему.",
      rating: 5,
      service_en: "Nissan Emergency",
      service_he: "חירום ניסאן", 
      service_ru: "Экстренная помощь Nissan"
    }
  ];

  const getName = (testimonial) => testimonial[`name_${currentLang}`];
  const getLocation = (testimonial) => testimonial[`location_${currentLang}`];
  const getText = (testimonial) => testimonial[`text_${currentLang}`];
  const getService = (testimonial) => testimonial[`service_${currentLang}`];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  // Auto-advance carousel
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, []);

  const getVisibleTestimonials = () => {
    const visible = [];
    for (let i = 0; i < 3; i++) {
      const index = (currentSlide + i) % testimonials.length;
      visible.push(testimonials[index]);
    }
    return visible;
  };

  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="container mx-auto px-4">
        <div 
          ref={titleRef}
          className={`max-w-4xl mx-auto text-center mb-16 scroll-animate ${titleVisible ? 'visible' : ''}`}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            {translations[currentLang].testimonials.title}
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed">
            {translations[currentLang].testimonials.subtitle}
          </p>
        </div>

        <div 
          ref={carouselRef}
          className={`relative max-w-6xl mx-auto scroll-animate-scale ${carouselVisible ? 'visible' : ''}`}
        >
          {/* Carousel Container */}
          <div className="overflow-hidden">
            <div className="grid md:grid-cols-3 gap-6">
              {getVisibleTestimonials().map((testimonial, index) => (
                <Card key={`${testimonial.id}-${currentSlide}`} className="bg-white/90 backdrop-blur-sm shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105">
                  <CardContent className="p-6">
                    {/* Quote Icon */}
                    <Quote className="w-8 h-8 text-blue-600 mb-4" />
                    
                    {/* Star Rating */}
                    <div className="flex items-center mb-4">
                      {[...Array(5)].map((_, i) => (
                        <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
                      ))}
                    </div>
                    
                    {/* Service Tag */}
                    <div className="inline-block px-3 py-1 bg-blue-100 text-blue-800 text-sm rounded-full mb-4">
                      {getService(testimonial)}
                    </div>
                    
                    {/* Testimonial Text */}
                    <p className="text-gray-700 leading-relaxed mb-6 min-h-[120px]">
                      "{getText(testimonial)}"
                    </p>
                    
                    {/* Customer Info */}
                    <div className="border-t border-gray-200 pt-4">
                      <h4 className="font-semibold text-gray-900">
                        {getName(testimonial)}
                      </h4>
                      <p className="text-gray-600 text-sm">
                        {getLocation(testimonial)}
                      </p>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>

          {/* Navigation Buttons */}
          <Button
            variant="outline"
            size="icon"
            className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/80 backdrop-blur-sm border-2 border-blue-200 hover:bg-blue-600 hover:text-white transition-all"
            onClick={prevSlide}
          >
            <ChevronLeft className="w-5 h-5" />
          </Button>
          
          <Button
            variant="outline"
            size="icon"
            className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/80 backdrop-blur-sm border-2 border-blue-200 hover:bg-blue-600 hover:text-white transition-all"
            onClick={nextSlide}
          >
            <ChevronRight className="w-5 h-5" />
          </Button>

          {/* Dots Indicator */}
          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === currentSlide 
                    ? 'bg-blue-600 scale-125' 
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-8 shadow-lg max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              {translations[currentLang].testimonials.cta.title}
            </h3>
            <p className="text-gray-600 mb-6">
              {translations[currentLang].testimonials.cta.description}
            </p>
            <Button 
              size="lg"
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 text-lg"
              onClick={() => window.open('tel:+972553002025')}
            >
              {translations[currentLang].testimonials.cta.button}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;